import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Bookkeeping from "../pages/bookkeeping/page";
import Consulting from "../pages/consulting/page";
import Properties from "../pages/properties/page";
import MatchLineup from "../pages/matchlineup/page";
import Alabaster from "../pages/alabaster/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/bookkeeping",
    element: <Bookkeeping />,
  },
  {
    path: "/consulting",
    element: <Consulting />,
  },
  {
    path: "/properties",
    element: <Properties />,
  },
  {
    path: "/matchlineup",
    element: <MatchLineup />,
  },
  {
    path: "/alabaster",
    element: <Alabaster />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;